export class SavedCommunity {
  Name: string;
  CommunityId: number;
  ModifiedOn: string;
}
